import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./Riderdatatable.css";
import Banner2 from "../Banner/Banner2";
import Baseurl from "../BaseURL/Baseurl";

function Ridernametable() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [, setError] = useState(null);
  const [key, setKeys] = useState(null);
  // const navigate = useNavigate();

  const { id } = useParams();
  const retrievedData = JSON.parse(localStorage.getItem("RacereName"));
  console.log(retrievedData.item.Driver, "usamaid=======>");
  const Usama = async () => {
    try {
      const response = await axios.get(
        `${Baseurl.baseurl}api/get-race-data/${id}`
      );
      console.log(response, "usamaconsole");
      setData(response?.data?.csv_data);
      setKeys(Object.keys(response?.data?.csv_data?.[0]));
    } catch (err) {
      setError(err.message);
    }
  };
  useEffect(() => {
    Usama();
    window.scrollTo(0, 0);
  }, []);
  console.log(key, "usamareces");
  useEffect(() => {
    const fakeAsyncAction = async () => {
      await new Promise((resolve) => setTimeout(resolve, 2000)); // Simulating a 2-second delay
      setLoading(false);
    };

    fakeAsyncAction();
  }, []);
  const Loader = () => {
    return (
      <div className="loader-wrapper">
        <div className="loader">
          <img
            className="loaderimg"
            src="/assets/images/loader.gif"
            alt="loader"
          />
        </div>
      </div>
    );
  };
  return (
    <>
      {/* {loading && <Loader />} */}
      <Banner2
        title="Racing"
        slug="Informations"
        backgroundImage="/assets/images/banner/video-banner-1.jpg"
      />
      <div className="container">
        <div className="row">
          <div className="col-md-3" style={{ width: "auto" }}>
            <h2 style={{ fontSize: "auto" }}>{retrievedData.item.Driver}</h2>
          </div>
          <div className="col-md-3">
            <img
              src={`https://${retrievedData.item.Rider_Country_Img}`} // Updated line
              alt="Country"
              style={{ scale: "1.5", marginTop: "15px" }}
              onLoad={() =>
                console.log(
                  `Image loaded: ${retrievedData.item.Rider_Country_Img}`
                )
              }
              onError={() =>
                console.error(
                  `Error loading image: ${retrievedData.item.Rider_Country_Img}`
                )
              }
            />
          </div>
          <div className="col-md-6"></div>
        </div>
        <div className="row">
          <div className="col-md-3 d-flex">
            &nbsp;<h5 style={{ color: "rgb(238, 18, 67)" }}>Born:</h5>
            <h5 className="text-center" style={{ fontSize: "auto" }}>
              &nbsp;{retrievedData.item.Born}
            </h5>
          </div>
          <div className="col-md-9"></div>
        </div>
        <div className="row">
          <div className="col-md-3 d-flex">
            &nbsp;<h5 style={{ color: "rgb(238, 18, 67)" }}>Home:</h5>
            <h5 className="text-center" style={{ fontSize: "16px" }}>
              &nbsp;{retrievedData.item.Home}
            </h5>
          </div>
          <div className="col-md-9"></div>
        </div>
        <div className="row">
          <div className="col-md-3 d-flex">
            &nbsp;<h5 style={{ color: "rgb(238, 18, 67)" }}>Died: </h5>
            <h5 className="text-center" style={{ fontSize: "auto" }}>
              &nbsp;{retrievedData.item.Died}
            </h5>
          </div>
          <div className="col-md-9"></div>
        </div>
        <hr />
      </div>
      <div
        className="container"
        style={{
          border: "solid",
          padding: "10px",
          marginBottom: "10px",
          marginTop: "10px",
          borderRadius: "5px",
        }}
      >
        {data &&
          data?.map((e, index) => (
            <>
              <div className="tablees-container">
              {loading ? (
        <Loader />
      ) : (
                <table className="table  table-dark table-striped table-bordered border-light">
                  <thead>
                    <tr
                      key={index}
                      style={{ width: "auto", textAlign: "center" }}
                    >
                      {key &&
                        key.map((k) => (
                          <th
                            key={k}
                            scope="col"
                            style={{
                              width: "auto",
                              background: "#ee1243",
                              fontWeight: "bold",
                            }}
                          >
                            {k}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ width: "auto", textAlign: "center" }}>
                      {key && key.map((k) => <td>{e[k]}</td>)}
                    </tr>
                  </tbody>
                </table>
      )}
              </div>
            </>
          ))}
      </div>
    </>
  );
}

export default Ridernametable;
